<template>
  <div class="ba-w-100 ba-flex ba-gp-1 ba-f-column">
    <div class="header">
      <div class="header-title">
        <span class="ba-montserrat-600">{{ t.team_account_member_of_team }}</span>
        <div class="underline"/>
      </div>

      <div class='ba-box-search-input'>
        <input type='search' class='ba-input' :placeholder='t.dns_search' v-model="search" />
        <button class='ba-button'>
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-search' viewBox='0 0 16 16'>
            <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'/>
          </svg>
        </button>
      </div>

      <button
        class='ba-btn ba-md ba-blue add-button'
      >
        <i class="glyphicon glyphicon-plus ba-color-white1"></i>
        <span class="ba-montserrat-500 ba-color-white1" @click="showCreateModal = true">{{ t.new_team_access }}</span>
      </button>
    </div>

    <builderall-loader :loading="loading">
      <table class='ba-table ba-lg ba-lines ba-w-100'>
        <thead>
          <tr>
            <th>{{ t.status }}</th>
            <th>{{ t.label_name }}</th>
            <th>{{ t.key }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(va, i) in va_list"
          >
            <td>
              <label class='ba-switch ba-sm'
                     @click.prevent="changeStatus(va, i)"
              >
                <input type='checkbox' class='ba-checkbox' :checked="va.is_active">
                <span class='ba-slider'></span>
              </label>
            </td>
            <td>
              <input
                type="search"
                :class="[!va.is_active ? 'text_through' : '']"
                class="outline-zero"
                :id="'input-name-va-' + i"
                v-model="va.first_name"
                @focus="!va.is_active ? '' : verifyElement(va.first_name)"
                @blur="!va.is_active ? '' : save(va.id, i, va.first_name)"
                :readonly="!va.is_active"
              >
            </td>
            <td class="ba-flex ba-gp-04 ba-ai-center">
              <span>{{ va.access_key.substring(0, 20) + '...' }}</span>
              <button class='ba-btn ba-btn-normal ba-md ba-rounded'
                      ba-tooltip-position='top'
                      :ba-tooltip-title='t.label_button_dfc_c2_affiliate'
                      @click="copyLink(va.access_key)"
              >
                <builderall-icon code='b54c' />
              </button>
            </td>
            <td>
              <div class="ba-flex ba-gp-04 ba-jc-fe">
                <button class='ba-btn ba-btn-normal ba-md ba-rounded'
                        ba-tooltip-position='top'
                        :ba-tooltip-title='t.allowed_tools'
                        @click="openToolsModal(va)"
                >
                  <builderall-icon code='fb7e' />
                </button>

  <!--              <button class='ba-btn ba-md ba-rounded background-color&#45;&#45;buttons p-default'-->
  <!--                      ba-tooltip-position='top'-->
  <!--                      :ba-tooltip-title='t.logs_va'-->
  <!--                      @click="copyLink(va.access_key)"-->
  <!--              >-->
  <!--                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">-->
  <!--                  <g clip-path="url(#clip0_24_979)">-->
  <!--                    <path d="M11.3301 14.4545C12.9185 14.4545 14.2062 13.1317 14.2062 11.5C14.2062 9.86825 12.9185 8.54546 11.3301 8.54546C9.74174 8.54546 8.4541 9.86825 8.4541 11.5C8.4541 13.1317 9.74174 14.4545 11.3301 14.4545Z" class="svg-fill&#45;&#45;color"/>-->
  <!--                    <path d="M11.3301 18C13.2782 18.0009 15.1917 17.4693 16.8757 16.4593C18.5598 15.4493 19.9543 13.997 20.9171 12.2503C21.0427 12.0217 21.1086 11.7635 21.1086 11.5009C21.1086 11.2382 21.0427 10.98 20.9171 10.7515C19.9539 9.00491 18.5594 7.55266 16.8755 6.54242C15.1915 5.53218 13.2782 5 11.3301 5C9.38207 5 7.46875 5.53218 5.7848 6.54242C4.10085 7.55266 2.70634 9.00491 1.74312 10.7515C1.61761 10.98 1.55164 11.2382 1.55164 11.5009C1.55164 11.7635 1.61761 12.0217 1.74312 12.2503C2.70601 13.997 4.10048 15.4493 5.78454 16.4593C7.4686 17.4693 9.38209 18.0009 11.3301 18ZM11.3301 7.16511C12.1612 7.16511 12.9735 7.41929 13.6645 7.89551C14.3555 8.37173 14.894 9.0486 15.2121 9.84053C15.5301 10.6325 15.6133 11.5039 15.4512 12.3446C15.289 13.1853 14.8889 13.9575 14.3012 14.5636C13.7136 15.1697 12.9649 15.5825 12.1499 15.7497C11.3348 15.917 10.49 15.8311 9.72219 15.5031C8.95442 15.1751 8.29819 14.6196 7.8365 13.9069C7.3748 13.1942 7.12838 12.3562 7.12838 11.4991C7.12838 10.3496 7.57106 9.24727 8.35904 8.43449C9.14702 7.62172 10.2158 7.16511 11.3301 7.16511Z" class="svg-fill&#45;&#45;color"/>-->
  <!--                  </g>-->
  <!--                  <defs>-->
  <!--                    <clipPath id="clip0_24_979">-->
  <!--                      <rect width="23" height="23" class="svg-fill&#45;&#45;color"/>-->
  <!--                    </clipPath>-->
  <!--                  </defs>-->
  <!--                </svg>-->
  <!--              </button>-->


                <button class='ba-btn ba-btn-normal ba-md ba-rounded'
                        ba-tooltip-position='top'
                        :ba-tooltip-title='t.va_edit_title'
                        @click="showEditModalMethod(va.id, i)"
                >
                  <builderall-icon code='edit' />
                </button>

                <button class='ba-btn ba-btn-trash ba-md ba-rounded'
                        ba-tooltip-position='top'
                        :ba-tooltip-title='t.delete_user'
                        @click="deleteVA(va)"
                >
                  <builderall-icon code='trash' />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </builderall-loader>

    <div class="ba-modal"
         v-if="showCreateModal"
         @click="setToggleCreateModal ? emitToggleCreateModal() : ''"
    >
      <div
        class="ba-modal-content ba-flex ba-f-column ba-gp-3 ba-ai-end"
        @mouseleave="setToggleCreateModal = true" @mouseover="setToggleCreateModal = false"
      >
        <div class="ba-modal--header">
          <div class="header ba-flex ba-jc-sb">
            <h5 class="ba-montserrat-600 ba-color-blue1">{{ t.team_account_member_of_team }}</h5>
            <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"
                 @click="emitToggleCreateModal" class="cursor-pointer">
              <g clip-path="url(#clip0_286_4540)">
                <path d="M11.0644 0.5C5.02466 0.5 0.128784 5.4247 0.128784 11.5C0.128784 17.5753 5.02466 22.5 11.0644 22.5C17.1041 22.5 22 17.5753 22 11.5C22 5.4247 17.1041 0.5 11.0644 0.5ZM15.1986 14.4915C15.519 14.8138 15.519 15.3357 15.1986 15.658C15.0384 15.8197 14.8284 15.9 14.6185 15.9C14.4085 15.9 14.1985 15.8197 14.0383 15.6586L11.0644 12.6666L8.09046 15.658C7.93025 15.8197 7.72028 15.9 7.51032 15.9C7.30036 15.9 7.09039 15.8197 6.93019 15.6586C6.60977 15.3363 6.60977 14.8143 6.93019 14.492L9.90467 11.5L6.93073 8.50855C6.61032 8.18625 6.61032 7.6643 6.93073 7.342C7.25115 7.0197 7.77004 7.0197 8.09046 7.342L11.0644 10.3335L14.0383 7.342C14.3587 7.0197 14.8776 7.0197 15.1981 7.342C15.5185 7.6643 15.5185 8.18625 15.1981 8.50855L12.2241 11.5L15.1986 14.4915Z" fill="#95ACCC"/>
              </g>
              <defs>
                <clipPath id="clip0_286_4540">
                  <rect width="21.8712" height="22" fill="white" transform="translate(0.128784 0.5)"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="underline"></div>
        </div>

        <div class="ba-modal--content ba-flex ba-f-column ba-gp-1">
          <span class="ba-montserrat-500">{{ t.va_create_title }}</span>
          <input
            v-model="va_name"
            type='text'
            class='ba-input'
            :placeholder='t.va_create_placeholder'
          />
        </div>

        <div class="ba-modal--footer">
          <button class='ba-btn ba-lg ba-blue'
                  @click="save(null, null, va_name)"
          >
            {{ t.button_salvar }}
          </button>
        </div>
      </div>
    </div>

    <div class="ba-modal"
         v-if="showEditModal"
         @click="setToggleEditModal ? emitToggleEditModal() : ''"
    >
      <div
        class="ba-modal-content ba-flex ba-f-column ba-gp-3 ba-ai-end"
        @mouseleave="setToggleEditModal = true" @mouseover="setToggleEditModal = false"
      >
        <div class="ba-modal--header">
          <div class="header ba-flex ba-jc-sb">
            <h5 class="ba-montserrat-600 ba-color-blue1">{{ t.va_edit_title }}</h5>
            <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"
                 @click="emitToggleEditModal" class="cursor-pointer">
              <g clip-path="url(#clip0_286_4540)">
                <path d="M11.0644 0.5C5.02466 0.5 0.128784 5.4247 0.128784 11.5C0.128784 17.5753 5.02466 22.5 11.0644 22.5C17.1041 22.5 22 17.5753 22 11.5C22 5.4247 17.1041 0.5 11.0644 0.5ZM15.1986 14.4915C15.519 14.8138 15.519 15.3357 15.1986 15.658C15.0384 15.8197 14.8284 15.9 14.6185 15.9C14.4085 15.9 14.1985 15.8197 14.0383 15.6586L11.0644 12.6666L8.09046 15.658C7.93025 15.8197 7.72028 15.9 7.51032 15.9C7.30036 15.9 7.09039 15.8197 6.93019 15.6586C6.60977 15.3363 6.60977 14.8143 6.93019 14.492L9.90467 11.5L6.93073 8.50855C6.61032 8.18625 6.61032 7.6643 6.93073 7.342C7.25115 7.0197 7.77004 7.0197 8.09046 7.342L11.0644 10.3335L14.0383 7.342C14.3587 7.0197 14.8776 7.0197 15.1981 7.342C15.5185 7.6643 15.5185 8.18625 15.1981 8.50855L12.2241 11.5L15.1986 14.4915Z" fill="#95ACCC"/>
              </g>
              <defs>
                <clipPath id="clip0_286_4540">
                  <rect width="21.8712" height="22" fill="white" transform="translate(0.128784 0.5)"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="underline"></div>
        </div>

        <div class="ba-modal--content ba-flex ba-f-column ba-gp-1">
          <span class="ba-montserrat-500">{{ t.va_edit_title }}</span>
          <input
            v-model="va_name"
            type='text'
            class='ba-input'
            :placeholder='getTaName()'
          />
        </div>

        <div class="ba-modal--footer">
          <button class='ba-btn ba-lg ba-blue'
                  @click="save(editTaId, editTaIndex, va_name)"
          >
            {{ t.button_salvar }}
          </button>
        </div>
      </div>
    </div>

    <div class="ba-modal"
         v-if="showDeleteModal"
         @click="setToggleDeleteModal ? emitToggleDeleteModal() : ''"
    >
      <div
        class="ba-modal-content ba-flex ba-f-column ba-gp-3 ba-ai-end"
        @mouseleave="setToggleDeleteModal = true" @mouseover="setToggleDeleteModal = false"
      >
        <div class="ba-modal--header">
          <div class="header ba-flex ba-jc-sb">
            <h5 class="ba-montserrat-600 ba-color-blue1">{{ t.team_account_member_of_team }}</h5>
            <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"
                 @click="emitToggleDeleteModal" class="cursor-pointer">
              <g clip-path="url(#clip0_286_4540)">
                <path d="M11.0644 0.5C5.02466 0.5 0.128784 5.4247 0.128784 11.5C0.128784 17.5753 5.02466 22.5 11.0644 22.5C17.1041 22.5 22 17.5753 22 11.5C22 5.4247 17.1041 0.5 11.0644 0.5ZM15.1986 14.4915C15.519 14.8138 15.519 15.3357 15.1986 15.658C15.0384 15.8197 14.8284 15.9 14.6185 15.9C14.4085 15.9 14.1985 15.8197 14.0383 15.6586L11.0644 12.6666L8.09046 15.658C7.93025 15.8197 7.72028 15.9 7.51032 15.9C7.30036 15.9 7.09039 15.8197 6.93019 15.6586C6.60977 15.3363 6.60977 14.8143 6.93019 14.492L9.90467 11.5L6.93073 8.50855C6.61032 8.18625 6.61032 7.6643 6.93073 7.342C7.25115 7.0197 7.77004 7.0197 8.09046 7.342L11.0644 10.3335L14.0383 7.342C14.3587 7.0197 14.8776 7.0197 15.1981 7.342C15.5185 7.6643 15.5185 8.18625 15.1981 8.50855L12.2241 11.5L15.1986 14.4915Z" fill="#95ACCC"/>
              </g>
              <defs>
                <clipPath id="clip0_286_4540">
                  <rect width="21.8712" height="22" fill="white" transform="translate(0.128784 0.5)"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="underline"></div>
        </div>

        <div class="ba-modal--content ba-flex ba-f-column ba-gp-1">
          <span class="ba-montserrat-500">{{ t.confirm_delete_va }}</span>
          <div>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="warning_FILL1_wght400_GRAD0_opsz48 1">
                <path id="Vector" d="M0.75 15.75L9 1.5L17.25 15.75H0.75ZM9.07828 13.5563C9.23859 13.5563 9.37188 13.502 9.47813 13.3936C9.58438 13.2851 9.6375 13.1508 9.6375 12.9905C9.6375 12.8302 9.58328 12.6969 9.47484 12.5906C9.36639 12.4844 9.23202 12.4313 9.07172 12.4313C8.91141 12.4313 8.77813 12.4855 8.67188 12.5939C8.56563 12.7024 8.5125 12.8367 8.5125 12.997C8.5125 13.1573 8.56672 13.2906 8.67516 13.3969C8.78361 13.5031 8.91798 13.5563 9.07828 13.5563ZM8.5125 11.475H9.6375V7.275H8.5125V11.475Z" fill="#EE9500"/>
              </g>
            </svg>
            <span class="ba-montserrat-500 ba-color-dark5">{{ t.confirm_delete_va_obs }}</span>
          </div>
          <div v-if="isInstructor">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="warning_FILL1_wght400_GRAD0_opsz48 1">
                <path id="Vector" d="M0.75 15.75L9 1.5L17.25 15.75H0.75ZM9.07828 13.5563C9.23859 13.5563 9.37188 13.502 9.47813 13.3936C9.58438 13.2851 9.6375 13.1508 9.6375 12.9905C9.6375 12.8302 9.58328 12.6969 9.47484 12.5906C9.36639 12.4844 9.23202 12.4313 9.07172 12.4313C8.91141 12.4313 8.77813 12.4855 8.67188 12.5939C8.56563 12.7024 8.5125 12.8367 8.5125 12.997C8.5125 13.1573 8.56672 13.2906 8.67516 13.3969C8.78361 13.5031 8.91798 13.5563 9.07828 13.5563ZM8.5125 11.475H9.6375V7.275H8.5125V11.475Z" fill="#EE9500"/>
              </g>
            </svg>
            <span class="ba-montserrat-500 ba-color-dark5">{{ decodeString(t.is_insctructor_delete_va_obs) }}</span>
          </div>
        </div>

        <div class="ba-modal--footer">
          <button class='ba-btn ba-lg ba-blue'
                  @click.prevent="deleteTeamAccount()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M3.88066 5.71387C3.60889 5.71387 3.34825 5.82183 3.15608 6.014C2.96392 6.20616 2.85596 6.4668 2.85596 6.73857V16.1749C2.85596 16.6772 2.9549 17.1746 3.14712 17.6387C3.33935 18.1028 3.6211 18.5245 3.9763 18.8797C4.33149 19.2348 4.75316 19.5166 5.21724 19.7088C5.68132 19.9011 6.17872 20 6.68103 20H13.317C13.8193 20 14.3167 19.9011 14.7808 19.7088C15.2449 19.5166 15.6666 19.2348 16.0217 18.8797C16.3769 18.5245 16.6587 18.1028 16.8509 17.6387C17.0431 17.1746 17.1421 16.6772 17.1421 16.1749V6.73857C17.1421 6.60393 17.1156 6.47061 17.064 6.34623C17.0125 6.22185 16.9369 6.10885 16.8416 6.01368C16.7464 5.91852 16.6333 5.84306 16.5089 5.79162C16.3845 5.74017 16.2511 5.71375 16.1165 5.71387H3.88066ZM7.14162 15.7152C7.14162 15.9046 7.06638 16.0863 6.93246 16.2202C6.79853 16.3541 6.61689 16.4293 6.42749 16.4293C6.23809 16.4293 6.05645 16.3541 5.92252 16.2202C5.7886 16.0863 5.71336 15.9046 5.71336 15.7152V9.2854C5.71336 9.096 5.7886 8.91436 5.92252 8.78043C6.05645 8.64651 6.23809 8.57127 6.42749 8.57127C6.61689 8.57127 6.79853 8.64651 6.93246 8.78043C7.06638 8.91436 7.14162 9.096 7.14162 9.2854V15.7152ZM10.7132 15.7152C10.7132 15.9046 10.6379 16.0863 10.504 16.2202C10.3701 16.3541 10.1884 16.4293 9.99902 16.4293C9.80962 16.4293 9.62798 16.3541 9.49405 16.2202C9.36013 16.0863 9.28489 15.9046 9.28489 15.7152V9.2854C9.28489 9.096 9.36013 8.91436 9.49405 8.78043C9.62798 8.64651 9.80962 8.57127 9.99902 8.57127C10.1884 8.57127 10.3701 8.64651 10.504 8.78043C10.6379 8.91436 10.7132 9.096 10.7132 9.2854V15.7152ZM14.2847 15.7152C14.2847 15.9046 14.2094 16.0863 14.0755 16.2202C13.9416 16.3541 13.76 16.4293 13.5706 16.4293C13.3812 16.4293 13.1995 16.3541 13.0656 16.2202C12.9317 16.0863 12.8564 15.9046 12.8564 15.7152V9.2854C12.8564 9.096 12.9317 8.91436 13.0656 8.78043C13.1995 8.64651 13.3812 8.57127 13.5706 8.57127C13.76 8.57127 13.9416 8.64651 14.0755 8.78043C14.2094 8.91436 14.2847 9.096 14.2847 9.2854V15.7152Z" fill="white"/>
              <path d="M18.5696 3.16446C18.5451 2.88108 18.4135 2.61769 18.2016 2.42796C17.9897 2.23822 17.7134 2.13641 17.4291 2.14327H13.1916C13.1475 2.14327 13.1038 2.13458 13.0631 2.11769C13.0223 2.10081 12.9852 2.07606 12.954 2.04486C12.9228 2.01365 12.8981 1.97661 12.8812 1.93585C12.8643 1.89508 12.8556 1.85139 12.8556 1.80726V1.42826C12.8556 1.04992 12.7055 0.687033 12.4382 0.419258C12.171 0.151482 11.8083 0.000697192 11.43 0H8.56997C8.19117 0 7.82789 0.150477 7.56003 0.418328C7.29218 0.686179 7.14171 1.04946 7.14171 1.42826V1.80726C7.14171 1.89638 7.10631 1.98184 7.04329 2.04486C6.98028 2.10787 6.89481 2.14327 6.8057 2.14327H2.56916C2.28481 2.13641 2.00854 2.23822 1.79663 2.42796C1.58473 2.61769 1.45313 2.88108 1.42866 3.16446C1.4219 3.30913 1.44454 3.45368 1.49523 3.58935C1.54592 3.72503 1.62359 3.84901 1.72356 3.95381C1.82352 4.05862 1.9437 4.14206 2.07683 4.1991C2.20996 4.25613 2.35327 4.28558 2.4981 4.28566H17.5001C17.6451 4.28582 17.7886 4.25655 17.9219 4.19961C18.0553 4.14268 18.1757 4.05928 18.2758 3.95445C18.376 3.84962 18.4538 3.72555 18.5046 3.58976C18.5554 3.45397 18.5781 3.30928 18.5713 3.16446H18.5696ZM11.43 1.78533C11.43 1.88003 11.3924 1.97085 11.3254 2.03781C11.2585 2.10477 11.1676 2.14239 11.0729 2.14239H8.92703C8.83233 2.14239 8.74151 2.10477 8.67455 2.03781C8.60759 1.97085 8.56997 1.88003 8.56997 1.78533C8.56997 1.69063 8.60759 1.59981 8.67455 1.53284C8.74151 1.46588 8.83233 1.42826 8.92703 1.42826H11.0703C11.1174 1.42791 11.1641 1.43689 11.2078 1.45468C11.2514 1.47247 11.2911 1.49872 11.3245 1.53191C11.3579 1.5651 11.3845 1.60458 11.4026 1.64807C11.4207 1.69157 11.43 1.73821 11.43 1.78533Z" fill="white"/>
            </svg>
            {{ t.translations_office_delete_account }}
          </button>
        </div>
      </div>
    </div>

    <tools-modal v-if="showToolsModal" :tool-list="this.view.tool_list" :translation="this.t" :closeModal="saveTools"/>
  </div>
</template>

<script>
import qs from "qs";
import {Encryption} from '../../../../../public_html/internacional/public/scripts/front-encryption/encrypt-vue.js';
export default {
  name: "team-access",
  props: ["view"],
  data() {
    return {
      t: null,
      va_list: null,
      base_url: null,
      key: null,
      search: '',
      oldName: '',
      showCreateModal: false,
      setToggleCreateModal: true,
      showDeleteModal: false,
      isInstructor: false,
      setToggleDeleteModal: true,
      deleteVirtualAssistant: null,
      va_name: null,
      va_backup: null,
      showToolsModal: false,
      SelectedVA: null,
      tools: null,

      editTaId: null,
      editTaIndex: null,
      showEditModal: false,
      setToggleEditModal: true,
      loading: false
    }
  },
  created() {
    this.t = this.view.translation
    this.va_list = this.view.va_list
    this.va_backup = this.view.va_list
  },
  mounted() {
    this.base_url = window.location.pathname.replace(/\/$/g, '')
    this.encryption = new Encryption()
    this.generateKey();
  },
  methods: {
    verifyElement(data){
      this.oldName = data;
    },
    selectInput(key) {
      $('#input-name-va-' + key).focus()
    },
    emitToggleCreateModal() {
      this.showCreateModal = false
    },
    emitToggleDeleteModal() {
      this.showDeleteModal = false
    },
    emitToggleEditModal() {
      this.showEditModal = false
      this.clearTaEditData()
    },
    showEditModalMethod(id, index) {
      this.showEditModal = true
      this.editTaId = id
      this.editTaIndex = index
      this.va_name = this.va_list[index].first_name
    },
    getTaName() {
      let ta = this.va_list.filter(x => x.id === this.editTaId)

      return ta[0].first_name
    },
    deleteVA(va) {
      this.deleteVirtualAssistant = va
      this.showDeleteModal = true

      if(va.data && va.data.hasOwnProperty('elearning')) {
        if(va.data && va.data.elearning.hasOwnProperty('instructor_id')) {
          this.isInstructor = true
        }
      } else {
        this.isInstructor = false
      }
    },
    getDataToComponent(){
      this.processing = true
      this.getVaData()
    },
    _isEmpty(val) {
      return isEmpty(val);
    },
    openToolsModal(va) {
      this.SelectedVA = va
      this.showToolsModal = true
      this.tools = this.configureVATools(this.view.tool_list);
    },
    configureVATools(tools) {
      let t = [];
      for(let i = 0; i< this.SelectedVA.tools.length; i++){
        t.push(this.SelectedVA.tools[i].id);

        for (let l = 0; l < this.SelectedVA.tools[i].children.length; l++) {
          t.push(this.SelectedVA.tools[i].children[l].id);

          for (let k = 0; k < this.SelectedVA.tools[i].children[l].children.length; k++) {
            t.push(this.SelectedVA.tools[i].children[l].children[k].id);
          }
        }
      }

      for (let i = 0; i < tools.length; i++) {
        tools[i].selected = false;
        for (let j = 0; j < t.length; j++) {
          if (t[j] == tools[i].tool.id) {
            tools[i].selected = true;
          }
        }

        if(tools[i].children.length > 0){
          this.configureVATools(tools[i].children);
        }
      }
      return tools;
    },
    saveTools(action) {
      this.loading = true
      this.showToolsModal = false
      if (action == 'save') {
        let selectedTools = [];
        let group_tools = this.getSelectedTools(this.tools);

        for (let i = 0; i < group_tools.length; i++) {
          selectedTools.push(group_tools[i].id)
        }

        const url = `${this.base_url}/tools`;
        axios
          .post(url, qs.stringify({ id_va: this.encryption.encrypt(this.SelectedVA.id, this.view.encryption_key), tools: selectedTools }))
          .then(response => this.saveToolsResponse(response.data))
      }
      this.tools = null
      this.SelectedVA = null
      this.va_list = null
      setTimeout(() => {
        this.getVaData()
      }, 500)
    },
    saveToolsResponse(response) {
      if(response.success){
        alertMsg("success", this.t.save_va_tools_success)
      }else{
        alertMsg("error", this.t.save_va_tools_error)
      }

      this.tools = null
      this.SelectedVA = null
    },
    getSelectedTools: function(tools){
      let selectedTools = [];
      for (let j = 0; j < tools.length; j++) {
        if (tools[j].selected) {
          selectedTools.push(tools[j].tool);
        }
        if(tools[j].children.length > 0){
          let sl = this.getSelectedTools(tools[j].children)
          for (let i = 0; i < sl.length; i++) {
            selectedTools.push(sl[i])
          }
        }
      }
      return selectedTools;
    },
    getVaData(){
      var vm = this;
      this.va_list = []
      axios
        .get(this.view.routes.rota_office_get_virtual_assistant_data)
        .then(function (response) {
          if (response.data.success)
          {
            vm.va_list = response.data.data;
            vm.va_backup = response.data.data;
            vm.getVa = true;
          }
          else
          {
            alertMsg(
              "error",
              vm.t.dns_ocorreu_erro
            );
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => this.loading = false)
    },
    copyLink(text) {
      var _input = document.createElement('input');

      document.body.appendChild(_input);

      _input.value = text.trim();
      _input.select();

      document.execCommand('copy');
      alertMsg("info", this.t.copied);
    },
    save(id = null, index, va_name = null) {
      if (id == null) {
        const url = `${this.base_url}/create`
        let key = this.makeKey(32)
        axios
          .post(url, qs.stringify({ name: this.va_name, key: key }))
          .then(response => this.createResponse(response.data))
          .finally(() => this.showCreateModal = false)

      } else if (this.oldName != va_name) {
        const url = `${this.base_url}/edit`
        let encrypt = this.encryption.encrypt(this.va_list[index].id, this.view.encryption_key)
        axios
          .post(url, { name: va_name, id: encrypt })
          .then(response => {
            this.getVaData()
            this.editResponse(response.data.status, index)
          })
          .finally(() => this.afterEditResponse())
      }
    },
    afterEditResponse() {
      this.clearTaEditData()
      this.showEditModal = false
    },
    clearTaEditData() {
      this.editTaId = null
      this.editTaIndex = null
      this.oldName = ''
      this.va_name = ''
    },
     deleteTeamAccount() {
      const url = `${this.base_url}/delete`;
      axios
        .post(url, { id: this.encryption.encrypt(this.deleteVirtualAssistant.id, this.view.encryption_key) })
        .then(response => this.deleteResponse(response.data.status, this.idx));
    },
    deleteResponse(result, index) {
      if (result) {
        alertMsg("success", this.t.success_delete_va);
      } else {
        alertMsg("error", this.t.ocorreu_erro);
      }
      this.getDataToComponent()
      this.closeModal()
    },
    closeModal() {
      this.showDeleteModal = false
      this.deleteVirtualAssistant = null
    },
    editResponse(result, index) {
      if (result) {
        alertMsg("success", this.t.va_edit_success);
      } else {
        alertMsg("error", this.t.va_edit_error);
      }
    },
    createResponse(data) {
      if (data.success && data.code == 0)
      {
        this.getDataToComponent()
        alertMsg("success", this.t.va_create_success);
      }
      else
      {
        alertMsg("error", this.t.va_create_error);
      }
    },
    changeStatus(element, key) {
      let url = `${this.base_url}/change-status/${this.encryption.encrypt(element.id, this.view.encryption_key)}`;
      axios
        .get(url)
        .then(response => {
          this.changeListStatus(response.data.status, element, key);
        });
    },
    changeListStatus(result, element, key) {
      if (!result) {
        alertMsg("error", this.t.change_va_status_error);
      }
      document.activeElement.blur();
      element.is_active = !element.is_active;
    },
    generateKey(){
      let timestamp = new Date().getTime();
      let hash = Math.floor(Math.random() * 256) + Math.floor(Math.random() * 256);
      this.key = this.view.user.id + timestamp + hash
    },
    makeKey(length) {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789#$@!*";
      for (var i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    },
    searchValue(val) {
      var regex = new RegExp(val.toLowerCase(), "i");

      this.va_list = this.va_list.filter(x => regex.test(x.first_name))
    },
    decodeString(string) {
      return new DOMParser().parseFromString(string, 'text/html').querySelector('body').textContent;
    }
  },
  watch: {
    search(newVal) {
      if (newVal != '') {
        this.searchValue(newVal)
      } else {
        this.getVaData()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  height: 36.58px;
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 16px;

  .header-title {
    width: auto;
    min-width: 50%;

    span {
      font-size: 14px;
      line-height: 16.5px;
      color: #4D5D71;
    }
  }

  .add-button {
    height: 100%;
    align-items: baseline !important;

    span, i {
      font-size: 12px !important;
    }
  }
}
.underline {
  margin-top: 9px;
  width: 100%;
  background-color: #C4D1E0;
  height: 1px;
}
.p-default {
  padding: 1rem !important;
}

.background-color--buttons {
  background-color: #EFF2F8;

  .svg-fill--color {
    fill: #8E9EB2;
  }
}
.background-color--buttons:hover {
  background-color: #0080fc;

  &.delete {
    background-color: rgba(243, 85, 88, 0.20) !important;

    .svg-fill--color {
      fill: #F35558 !important;
    }
  }

  .svg-fill--color {
    fill: #FFFFFF;
  }
}
.text_through{
  text-decoration:line-through;
}
.outline-zero {
  border: 0 !important;
  outline: none !important;
}
.ba-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1500;
  width: 100%;
  height: 105vh;
  background: rgba( 163, 163, 163, 0.25 );
  backdrop-filter: blur( 4px );
  -webkit-backdrop-filter: blur( 4px );

  display: flex;
  align-items: center;
  justify-content: center;

  .ba-modal-content {
    min-width: 600px;
    max-width: 950px;
    min-height: 260px;
    border-radius: 8px;
    background: #FFF;

    padding: 40px 20px;
    gap: 20px;

    .ba-modal--content {
      width: 100%;
    }
    .ba-modal--header {
      width: 100%;
      .header {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/team-access/TeamAccess.vue